import { ROOMS } from "#constants/classOptions"
import { type Uuid } from "#customTypes/globalTypes"
import { type DatabaseObject } from "#customTypes/types"

export const HELP_REQUEST_PRIORITY = {
  LOW: "low",
  URGENT: "urgent",
} as const

export type HelpRequestPriority =
  (typeof HELP_REQUEST_PRIORITY)[keyof typeof HELP_REQUEST_PRIORITY]

export const HELP_REQUEST_STATUS = {
  ACTIVE: "active",
  RESOLVED: "resolved",
} as const

export type HelpRequestStatus =
  (typeof HELP_REQUEST_STATUS)[keyof typeof HELP_REQUEST_STATUS]

export const FRONT_DESK_ROOM = "FRONT_DESK_ROOM" as const
export type HelpRequestRoom = ROOMS | typeof FRONT_DESK_ROOM

export interface HelpRequestConstructor extends DatabaseObject {
  id: Uuid
  room: HelpRequestRoom
  priority: HelpRequestPriority
  comment?: string
  status: HelpRequestStatus
  acknowledgedByIds: Uuid[]
}
